import { Button, IconButton, LinearProgress, Typography } from '@mui/material'
import React, { useState } from 'react'
import { getActivityActive } from '../../../reducer/activityActiveSlice';
import { useSelector } from 'react-redux';
import AddActivity from '../EOCActivity/AddActivity';
import DataGridMyEOC from '../ComponentReuse/DataGridMyEOC';
import ActivityDes from '../../myeoc/manageActivityEOC/ActivityDes';
import EditActivity from '../EOCActivity/EditActivity';
import DeleteActivity from '../EOCActivity/DeleteActivity';
import DetailActivity from '../EOCActivity/DetailActivity';
import { DataGridPro, GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid-pro';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import dayjs from 'dayjs';


function TabActivity() {

    const activityActive = useSelector(getActivityActive);
    const [open, setOpen] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openDetail, setOpenDetail] = useState(false);
    const [dataActivity, setDataActivity] = useState();

    const handleClickEdit = (row) => {
        console.log("handleClickEdit", row);
        setOpenEdit(true);
        setDataActivity(row);
    };

    const handleClickDelete = (row) => {
        console.log("handleClickDelete", row);
        setOpenDelete(true);
        setDataActivity(row);
    };

    const handleClickDetail = (row) => {
        console.log("handleClickDetail", row);
        setOpenDetail(true);
        setDataActivity(row);
    };

    function CustomToolbar(props) {

        return (
            <GridToolbarContainer {...props} className="flex justify-between mt-2 ml-2 mr-3">
                <GridToolbarQuickFilter variant="outlined" size="small" />

            </GridToolbarContainer>
        );
    }

    const activity_columns = [
            {
                field: 'create_timestamp',
                headerName: 'วันที่เริ่มต้น',
                flex: 1,
                align: 'center',
                headerAlign: 'center',
                valueGetter: (value) => {
                    if (value?.row?.create_timestamp) {
                        const date = new Date(parseInt(value?.row?.create_timestamp));
                        let startEOCDate = dayjs(date).locale("th").format("DD MMMM YYYY");
                        return startEOCDate;
                    }
                }
            },
            {
                field: 'eoc_activity',
                headerName: 'กิจกรรม',
                flex: 1,
                align: 'center',
                headerAlign: 'center',
                valueGetter: (value) => {
                    if (value?.row?.activity) {
                        const join_activity = value?.row?.activity.join();
                        return join_activity;
                    } else {
                        return;
                    }
                }
            },
            {
                field: 'actions',
                headerName: '',
                flex: 1,
                align: 'right',
                headerAlign: 'center',
                renderCell: (params) => {
                    return <div>
                        <IconButton onClick={() => handleClickEdit(params?.row)}>
                            <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => handleClickDelete(params?.row)}>
                            <DeleteIcon />
                        </IconButton>
                    </div>
                }
            },
            {
                field: 'details',
                headerName: '',
                flex: 1,
                align: 'left',
                headerAlign: 'center',
                renderCell: (params) => {
                    return <Button variant="outlined" size='small' onClick={() => handleClickDetail(params?.row)}>รายละเอียด</Button>;
                }
            },
        ];

    return (
        <div className='flex flex-col gap-4 min-h-[calc(100vh-500px)]'>
            <div className='flex flex-none justify-end'>
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: "#cd6c4a",
                    }}
                    onClick={() => setOpen(true)}
                >+ บันทึกกิจกรรม</Button>
            </div>
            <div className='flex-grow h-[350px] w-full'>
                {/* <DataGridMyEOC
                    activityData={true}
                    actions={true}
                    rows={activityActive ? activityActive : []}
                    handleClickEdit={handleClickEdit}
                    handleClickDelete={handleClickDelete}
                    handleClickDetail={handleClickDetail}
                /> */}
                <DataGridPro
                    columns={activity_columns}
                    rows={activityActive ? activityActive : []}
                    slots={{ loadingOverlay: LinearProgress, toolbar: CustomToolbar }}
                    hideFooter
                    disableRowSelectionOnClick
                />
            </div>
            <EditActivity
                open={openEdit}
                setOpen={setOpenEdit}
                dataActivity={dataActivity}
            />
            <DeleteActivity
                open={openDelete}
                setOpen={setOpenDelete}
                dataActivity={dataActivity}
            />
            <DetailActivity
                open={openDetail}
                setOpen={setOpenDetail}
                dataActivity={dataActivity}
            />
            <AddActivity open={open} setOpen={setOpen} />
        </div>

    )
}

export default TabActivity